/** Report Builder chrome surfaces (toolbars, sidebars, workspace). */

export const REPORT_BUILDER_ROOT_CLASS =
  "flex flex-col h-full bg-slate-100 text-slate-900 dark:bg-slate-900 dark:text-white";

export const REPORT_BUILDER_OS_OUTER_CLASS =
  "h-full bg-gradient-to-bl from-slate-200/80 to-slate-100 w-full rounded-2xl text-slate-900 overflow-hidden flex flex-col dark:from-slate-700/50 dark:to-slate-700/40 dark:text-white";

export const REPORT_BUILDER_OS_INNER_CLASS =
  "flex flex-col h-full bg-slate-100 rounded-2xl overflow-hidden dark:bg-slate-900";

export const REPORT_BUILDER_CHROME_CLASS =
  "bg-white border-slate-200 dark:bg-slate-800 dark:border-slate-700";

export const REPORT_BUILDER_TOOLBAR_CLASS = `@container flex items-center gap-1 px-3 py-1.5 border-b ${REPORT_BUILDER_CHROME_CLASS}`;

export const REPORT_BUILDER_MENU_BAR_CLASS = `flex items-center h-9 px-2 border-b ${REPORT_BUILDER_CHROME_CLASS}`;

export const REPORT_BUILDER_SIDEBAR_CLASS =
  "h-full flex flex-col bg-white border-r border-slate-200 dark:bg-slate-800 dark:border-slate-700";

export const REPORT_BUILDER_SIDEBAR_FOOTER_CLASS =
  "px-1.5 py-2 border-t border-slate-200 space-y-1.5 flex-shrink-0 dark:border-slate-700";

/** Secondary actions in the slide navigation footer — pass as `className` on `Button outline`. */
export const REPORT_BUILDER_SIDEBAR_ACTION_BUTTON_CLASS =
  "w-full justify-center text-xs !bg-slate-100 !text-slate-800 border-slate-200 hover:!bg-slate-200 hover:!text-slate-900 dark:!bg-slate-700/60 dark:!text-slate-200 dark:border-slate-600 dark:hover:!bg-slate-600 dark:hover:!text-white";

export const REPORT_BUILDER_PROPERTIES_PANEL_CLASS =
  "w-96 h-full flex-shrink-0 z-30 rounded-2xl flex flex-col border border-slate-200 bg-white/95 text-slate-900 shadow-sm dark:border-transparent dark:bg-slate-700/95 dark:text-white";

export const REPORT_BUILDER_PANEL_TOGGLE_CLASS =
  "flex-shrink-0 flex items-center justify-center transition-colors duration-300 h-12 w-8 bg-slate-200 hover:bg-slate-300 text-slate-700 dark:bg-slate-700 dark:hover:bg-slate-600 dark:text-white";

export const REPORT_BUILDER_MENU_BUTTON_CLASS =
  "px-3 py-1.5 text-sm text-slate-700 hover:bg-slate-100 rounded transition-colors focus:outline-none dark:text-slate-300 dark:hover:bg-slate-700";

export const REPORT_BUILDER_MENU_BUTTON_OPEN_CLASS =
  "bg-slate-100 dark:bg-slate-700";

export const REPORT_BUILDER_APP_TITLE_CLASS =
  "flex items-center gap-2 px-3 text-sm font-semibold text-slate-900 dark:text-white";

export const REPORT_BUILDER_TOOLBAR_BUTTON_CLASS =
  "flex items-center gap-2 px-3 py-2 text-sm text-slate-700 hover:bg-slate-100 rounded-lg transition-colors focus:outline-none dark:text-slate-300 dark:hover:bg-slate-600";

export const REPORT_BUILDER_TOOLBAR_ICON_BUTTON_CLASS =
  "flex items-center justify-center w-8 h-8 rounded text-slate-600 hover:bg-slate-100 hover:text-slate-900 transition-colors dark:text-slate-300 dark:hover:bg-slate-700 dark:hover:text-white";

export const REPORT_BUILDER_MENU_DROPDOWN_CLASS =
  "absolute left-0 mt-1 origin-top-left rounded-lg bg-white shadow-lg ring-1 ring-black/5 focus:outline-none z-[100] dark:bg-slate-800 dark:ring-white/10";

export const REPORT_BUILDER_MENU_ITEM_ACTIVE_CLASS =
  "bg-slate-100 text-slate-900 dark:bg-slate-700 dark:text-white";

export const REPORT_BUILDER_MENU_ITEM_CLASS =
  "text-slate-700 dark:text-slate-200";

export const REPORT_BUILDER_MENU_SECTION_CLASS =
  "px-3 py-1.5 text-xs font-semibold text-slate-500 uppercase tracking-wider dark:text-slate-400";

export const REPORT_BUILDER_DIVIDER_CLASS = "bg-slate-200 dark:bg-slate-600";

export const REPORT_BUILDER_SECTION_BUTTON_CLASS =
  "w-full text-left cursor-pointer px-4 hover:bg-slate-100 select-none py-2 font-medium text-slate-900 focus:outline-none dark:hover:bg-slate-800/50 dark:text-white";

/** Uppercase field labels inside properties sections (Report Name, Orientation, etc.). */
export const REPORT_BUILDER_FIELD_LABEL_CLASS =
  "text-xs uppercase tracking-widest text-slate-800 dark:text-slate-300 font-mono";

export const REPORT_BUILDER_LAYER_SELECTED_CLASS = "bg-indigo-100 dark:bg-indigo-400";

export const REPORT_BUILDER_LAYER_HOVER_CLASS = "hover:bg-slate-100 dark:hover:bg-slate-800/50";

export const REPORT_BUILDER_LAYER_TEXT_SELECTED_CLASS =
  "text-slate-900 dark:text-white";

export const REPORT_BUILDER_LAYER_TEXT_CLASS = "text-slate-700 dark:text-slate-200";

export const REPORT_BUILDER_PAGE_ITEM_ACTIVE_CLASS =
  "bg-indigo-500 text-white dark:bg-indigo-400";

export const REPORT_BUILDER_PAGE_ITEM_CLASS =
  "bg-slate-100 hover:bg-slate-200 text-slate-800 dark:bg-slate-600/20 dark:hover:bg-slate-800/30 dark:text-slate-200";

export const REPORT_BUILDER_MUTED_TEXT_CLASS = "text-slate-500 dark:text-slate-400";

export const REPORT_BUILDER_INPUT_TEXTAREA_CLASS =
  "mt-2 block w-full rounded-xl border border-slate-200 bg-white px-3 py-1.5 text-base text-slate-900 outline-none placeholder:text-slate-400 focus:ring-2 focus:ring-indigo-400 focus:ring-offset-2 focus:ring-offset-white dark:border-transparent dark:bg-slate-800/90 dark:text-slate-200 dark:focus:ring-indigo-400 dark:focus:ring-offset-slate-700";
